import React from 'react';
import { CircularProgress } from '@mui/material';
import { ArrowBack, ArrowForward, Send, Refresh } from '@mui/icons-material';
import './FormNavigationButtons.css';
import { PrimaryButton, SecondaryButton } from '../common';

const FormNavigationButtons = ({
  // Navigation state
  currentIndex = 0,
  formLength = 1,

  // Button state
  isLoading = false,
  isSubmitting = false,
  sended = false,

  // Handlers
  onBack,
  onNext,
  onSubmit,
  onToHome,

  // Conditional rendering
  showSubmitSection = false,
  showBackButton = true,
  showNextButton = true,

  // Submit button props
  canSubmitSubmission = true,
  hasBeenSubmitted = false,
  readOnly = false,
  previewMode = false,
  isTest = false,
  openResubmitDialog,

  // Custom styling
  containerStyle = {},
  containerClassName = '',
}) => {
  const canGoBack = currentIndex > 0 && !sended && !isLoading;
  const canGoNext = currentIndex < formLength - 1 && !isLoading;
  const isOnLastPage = currentIndex >= formLength - 1;

  const renderBackButton = () => {
    if (!showBackButton || currentIndex === 0 || sended || isLoading) {
      return null;
    }

    return (
      <div className="form-navigation-back">
        <SecondaryButton
          className="form-navigation-button"
          disabled={!canGoBack}
          onClick={onBack}
          size="small"
          startIcon={<ArrowBack sx={{ fontSize: '16px' }} />}
        >
          Back
          {isLoading && (
            <CircularProgress className="buttonProgress" size={16} />
          )}
        </SecondaryButton>
      </div>
    );
  };

  const renderNextButton = () => {
    if (!showNextButton || isOnLastPage) {
      return null;
    }

    return (
      <div className="form-navigation-next">
        <SecondaryButton
          className="form-navigation-button"
          disabled={!canGoNext}
          onClick={onNext}
          size="small"
          endIcon={<ArrowForward sx={{ fontSize: '16px' }} />}
        >
          Next
          {isLoading && (
            <CircularProgress className="buttonProgress" size={16} />
          )}
        </SecondaryButton>
      </div>
    );
  };

  const renderSubmitButton = () => {
    if (!isOnLastPage || !canSubmitSubmission) {
      return null;
    }

    return (
      <div className="form-navigation-submit">
        <PrimaryButton
          className="form-navigation-button"
          disabled={
            (sended ||
              isLoading ||
              isSubmitting ||
              !canSubmitSubmission ||
              readOnly ||
              previewMode) &&
            !isTest
          }
          size="small"
          onClick={hasBeenSubmitted ? openResubmitDialog : onSubmit}
          startIcon={
            hasBeenSubmitted ? (
              <Refresh sx={{ fontSize: '16px' }} />
            ) : (
              <Send sx={{ fontSize: '16px' }} />
            )
          }
        >
          {hasBeenSubmitted ? 'Resubmit' : 'Submit'}
          {(isLoading || isSubmitting) && (
            <CircularProgress
              className="buttonProgress"
              size={16}
              sx={{ color: '#fff' }}
            />
          )}
        </PrimaryButton>
      </div>
    );
  };

  return (
    <div
      className={`form-navigation-container ${containerClassName}`}
      style={containerStyle}
    >
      {renderBackButton()}
      {renderSubmitButton()}
      {renderNextButton()}
    </div>
  );
};

export default FormNavigationButtons;
